<template>
  <div class="app-container">
    <!-- 城市公司信息展示 -->
    <el-card class="box-card">
      <div class="city-company-info">
        <h3>城市公司信息</h3>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="账套ID">{{ rowItem.id }}</el-descriptions-item>
          <el-descriptions-item label="城市公司名称">{{ getCityCompanyName() }}</el-descriptions-item>
          <!-- <el-descriptions-item label="msgKey">{{ rowItem.msgKey }}</el-descriptions-item>
          <el-descriptions-item label="appKey">{{ rowItem.appKey }}</el-descriptions-item> -->
        </el-descriptions>
      </div>
    </el-card>
    
    <el-card class="box-card mt10">
      <!-- 筛选区域 -->
      <div class="filter-container">
        <div class="filter-wrapper">
          <div class="filter-item">
            <span class="filter-label">状态：</span>
            <el-radio-group v-model="query.state" size="small">
              <el-radio-button :label="1">启用</el-radio-button>
              <el-radio-button :label="0">禁用</el-radio-button>
            </el-radio-group>
          </div>
          <div class="filter-item">
            <span class="filter-label">商户号：</span>
            <el-input 
              v-model="query.cusId" 
              placeholder="请输入商户号" 
              size="small" 
              clearable 
              class="merchant-input"
              prefix-icon="el-icon-search"
            ></el-input>
          </div>
          <el-button type="info" @click="handleFilter" plain size="mini" class="reset-btn">重置</el-button>
        </div>
      </div>
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增</el-button>
          <el-button type="info" @click="handleBack" plain size="mini">返回上一页</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="filteredList" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="商户号" prop="cusId" align="center" />
        <el-table-column label="机构号" prop="orgId" align="center" value="56366705137XAWM"/>
        <el-table-column label="是否主商户号" prop="state" align="center">
          <template slot-scope="{row}">
            <span v-if="row.cusId==='56366705137XAWM'" class="is-main-merchant">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="应用ID" prop="appId" align="center" />
        <el-table-column label="版本号" prop="version" align="center" />
        <el-table-column label="公钥" prop="pubKey" align="center" show-overflow-tooltip />
        <el-table-column label="私钥 " prop="privateKey" align="center" show-overflow-tooltip />
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" align="center" width="160" />
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" /> -->
    </el-card>
    <!-- 新建表单 -->
    <youAccount-add ref="youAccountAdd" :cityCompanyOptions="cityCompanyOptions" :yongyouConfigId="rowItem.id" @created="doQueryList({})" />
  </div>
</template>

<script>
import youAccountAdd from './edit'
import yongyouConfigApi from '@/api/config/yongyouConfig'
import Pagination from '@/components/Pagination'
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  props: ['rowItem'],
  components: {
    Pagination,
    youAccountAdd
  },
  data() {
    return {
      list: [],
      originalList: [], // 原始数据列表
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        state: 1, // 默认启用
        cusId: '', // 商户号
      },
      selectItems: [],
      cityCompanyOptions: [],
    }
  },
  computed: {
    // 过滤后的列表
    filteredList() {
      let result = [...this.originalList]
      
      // 按状态过滤
      if (this.query.state !== null && this.query.state !== undefined) {
        result = result.filter(item => item.state === this.query.state)
      }
      
      // 按商户号过滤
      if (this.query.cusId && this.query.cusId.trim()) {
        const keyword = this.query.cusId.trim().toLowerCase()
        result = result.filter(item => 
          item.cusId && item.cusId.toLowerCase().includes(keyword)
        )
      }
      
      return result
    }
  },
  created() {
    this.getCityCompany()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    // 获取城市公司名称
    getCityCompanyName() {
      if (!this.rowItem || !this.rowItem.cityCompanyListVO || !this.rowItem.cityCompanyListVO.length) {
        return '-'
      }
      return this.rowItem.cityCompanyListVO[0].name || '-'
    },
    getCityCompany() {
      cityCompanyApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(res => {
        this.cityCompanyOptions = res.data.list
      })
    },
    handleFilter() {
      this.query.state = 1
      this.query.cusId = ''
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        // 'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      this.listLoading = true
      return yongyouConfigApi.configPayList({yongyouConfigId: this.rowItem.id})
        .then(data => {
          // 保存原始数据，用于前端过滤
          this.originalList = data.data || []
          this.list = data.data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      yongyouConfigApi.UpdateConfigPayState({ payId: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.youAccountAdd.handleCreate(this.total)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.youAccountShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.youAccountAdd.handleUpdate(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.city-company-info {
  h3 {
    margin: 0 0 20px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
  }
}
.is-main-merchant {
  color: #f56c6c;
  font-weight: bold;
}
.filter-container {
  .filter-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    
    .filter-item {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      
      .filter-label {
        margin-right: 8px;
        white-space: nowrap;
      }
    }
    
    .reset-btn {
      margin-left: 0;
    }
  }
}
</style>
